import React from 'react';

import { Wrapper } from './FormError.style';

type Props = Record<string, unknown>;

const FormError: React.FC<Props> = ({ children }) => <Wrapper>{children}</Wrapper>;

export default FormError;
